// Este script soluciona el problema de idioma en los productos relacionados del modal add to cart
// Shopify Translate & Adapt: añade el prefijo de idioma actual a los enlaces de productos relacionados

document.addEventListener('DOMContentLoaded', function() {
  // Función para obtener el prefijo de idioma activo
  function getLangPrefix() {
    var path = window.location.pathname;
    if (path.startsWith('/en/')) return '/en';
    if (path.startsWith('/ca/')) return '/ca';
    return '';
  }

  // Función para actualizar los href de los productos relacionados
  function updateRelatedLinks() {
    var langPrefix = getLangPrefix();
    var relatedLinks = document.querySelectorAll('.tt-modal-slider-js a[href^="/products/"]');
    relatedLinks.forEach(function(link) {
      var href = link.getAttribute('href');
      // Evitar duplicar el prefijo
      if (langPrefix && !href.startsWith(langPrefix + '/products/')) {
        link.setAttribute('href', langPrefix + href);
      } else if (!langPrefix && (href.startsWith('/en/products/') || href.startsWith('/ca/products/'))) {
        // Si estamos en español, quitar prefijo si lo tuviera
        link.setAttribute('href', href.replace(/^\/(en|ca)(?=\/products\/)/, ''));
      }
    });
  }

  // Actualizar los enlaces cada vez que se muestre el modal
  var modal = document.getElementById('modalAddToCartProduct');
  if (modal) {
    modal.addEventListener('show.bs.modal', updateRelatedLinks);
    // Por si ya está visible al cargar
    if (modal.classList.contains('show')) updateRelatedLinks();
  }

  // Fallback: actualizar al hacer clic en cualquier producto relacionado
  var relatedContainer = document.querySelector('.tt-modal-slider-js');
  if (relatedContainer) {
    relatedContainer.addEventListener('click', function(e) {
      var link = e.target.closest('a');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || !href.match(/^(\/|)(en|ca)?\/?\/products\//)) return;
      // Detectar idioma activo
      var langPrefix = getLangPrefix();
      // Redirigir con el idioma activo
      e.preventDefault();
      window.location.href = link.getAttribute('href');
    });
  }
});
